import { useEffect, useRef, useState } from 'react';

export function useMeasuredFontSize() {
    const ref = useRef<HTMLDivElement | null>(null);
    const [fontSize, setFontSize] = useState<number | null>(null);

    useEffect(() => {
        if (!ref.current) return;

        let inner: HTMLElement | null = null;

        const update = () => {
            if (!ref.current) return;

            if (!inner) {
                inner = ref.current.querySelector('*') as HTMLElement | null;
            }

            if (!inner) return;

            const style = window.getComputedStyle(inner);
            const size = parseFloat(style.fontSize || '0');

            setFontSize(size);
        };

        update();

        const observer = new ResizeObserver(update);
        observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return { ref, fontSize };
}
